import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";
import { Activity } from "@mapmycustomers/shared/types/entity";
import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import i18nService from "@app/config/I18nService";
import isAutoEmailActivity from "@app/util/email/isAutoEmailActivity";
import ActivityTypesFilter, {
  ACTIVITY_TYPES_FILTER_OPERATORS,
} from "@app/util/filters/ActivityTypesFilter";

import Field, { FieldProperties } from "./Field";

class ActivityTypeField extends Field {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      customFilterConfig: {
        defaultInstance: "activityType",
        filterInstances: {
          activityType: ActivityTypesFilter,
        },
        operators: [...ACTIVITY_TYPES_FILTER_OPERATORS],
      },
      customGridProperties: {
        cellRenderer: "activityTypeCellRenderer",
      },
      features: [
        FieldFeature.FILTERABLE,
        FieldFeature.ACTIVITY_TYPE_FIELD,
        FieldFeature.SUPPORTS_SET_FILTER,
        FieldFeature.SORTABLE,
        FieldFeature.REQUIRED,
      ],
      filterType: FieldType.ID,
      importProperties: { name: "crmActivityTypeName", required: true },
      platformFilterNames: ["crmActivityTypeId", "crmActivityType.id"],
      platformName: "crmActivityTypeId",
      type: FieldType.STRING,
      valueFormatter: (activity: unknown, value: unknown) => {
        if (isAutoEmailActivity(activity as Activity)) {
          return i18nService.formatMessage(
            {
              id: "activityTypeField.autoEmail",
              defaultMessage: "MMC Email",
              description: "Auto email activity type name",
            },
            "MMC Email"
          );
        }
        return (value as Pick<ActivityType, "id" | "name">).name;
      },
      valueGetter: "crmActivityType",
      ...data,
    });
  }
}

export default ActivityTypeField;
